export type SplitName = {
  name: string;
  lastName: string;
};

export const splitFullName = (fullName: string): SplitName => {
  const partes = fullName.trim().split(/\s+/).filter(Boolean);

  if (partes.length === 0) return { name: '', lastName: '' };
  if (partes.length === 1) return { name: partes[0], lastName: '' };

  return {
    name: partes.slice(0, -1).join(' '),
    lastName: partes[partes.length - 1],
  };
};
